




















































import { Component, Mixins, Prop } from "vue-property-decorator";
import BaseServiceMixin from "@/mixins/base.service.mixin";
import TwilioService from "@/services/twilio.service";
import { TwilioTaskModel } from "@/models/TwilioTaskModel";
import { ValidationObserver } from "vee-validate";
import eventBus from "@/common/bus";
import vueCustomScrollbar from "vue-custom-scrollbar";

@Component({
  components: {
    ValidationObserver,
    vueCustomScrollbar,
  },
})
export default class CancelTaskModal extends Mixins(BaseServiceMixin) {
  @Prop({ default: () => new TwilioTaskModel() })
  private task!: TwilioTaskModel;
  @Prop({ default: () => 0 })
  private companyId!: number;

  private twilioService!: TwilioService;
  private reason = "";

  public async created() {
    this.twilioService = new TwilioService(this.axiosInstance);
  }

  private async cancelTask() {
    eventBus.$emit("loading", true);
    try {
      await this.twilioService.cancelTwilioTask(this.companyId, this.task, this.reason);
      this.$emit("onCancelTask");
      this.$emit("close");
    } catch (error) {
      // Handle Error
    } finally {
      setTimeout(() => {
        eventBus.$emit("loading", false);
      }, 1000);
    }
  }
}
